import '../../App.css';
import React, {Component} from 'react';
import {Row, Col, Button,Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';

import NavBarTop from "./navbar";
import Footer from "./footer";
import groupCat from '../../cat';

class Category extends Component {
  constructor(props){
    super(props);
    this.state = {  
       group0:groupCat["piano"][0],
       group1:groupCat["piano"][1],
       group2:groupCat["piano"][2],
       group3:groupCat["piano"][3],
       group4:groupCat["piano"][4],
       instrument: "piano",
    };

    this.changeGroup = this.changeGroup.bind(this)
    this.setval = this.setval.bind(this)
  }
  componentDidMount(){
    document.title="International Young Artist Open Competition"
    var link1 = document.getElementById('favicon')
    var link2 = document.getElementById('touchicon')
    link1.href="/assets/iyao_logo.png"
    link2.href="/assets/iyao_logo.png"
    this.props.setval({comp:"iyao"})
  }
  setval(obj){
    this.setState(obj)
  }
  changeGroup(val){
   const _group = JSON.parse(JSON.stringify(groupCat[val]))
   //alert(JSON.stringify(_group))
   this.setState({group0:_group[0],group1:_group[1],group2:_group[2],group3:_group[3],group4:_group[4],instrument:val})
  }
  render(){
    return (
      <div className="category-div">
        <video loop autoPlay muted id="myVideo">
          <source
            src="../assets/category.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        
        <div id="cat-content"> 
          <button className={[(this.state.instrument=="piano")?"cat-button-selected":"cat-button"].join(" ")} 
            style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("piano")}}>Piano</button>
          <button className={[(this.state.instrument=="strings")?"cat-button-selected":"cat-button"].join(" ")} 
             style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("strings")}}>Strings</button>
          <button className={[(this.state.instrument=="vocal")?"cat-button-selected":"cat-button"].join(" ")} 
             style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("vocal")}}>Vocal</button>
          <button className={[(this.state.instrument=="woodwind")?"cat-button-selected":"cat-button"].join(" ")} 
             style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("woodwind")}}>Woodwind</button>
          <button className={[(this.state.instrument=="brass")?"cat-button-selected":"cat-button"].join(" ")} 
             style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("brass")}}>Brass</button>
          <button className={[(this.state.instrument=="harp")?"cat-button-selected":"cat-button"].join(" ")} 
             style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("harp")}}>Harp</button>
          <button className={[(this.state.instrument=="guitar")?"cat-button-selected":"cat-button"].join(" ")} 
             style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("guitar")}}>Guitar</button>  
          <button className={[(this.state.instrument=="recorder")?"cat-button-selected":"cat-button"].join(" ")} 
             style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("recorder")}}>Recorder</button>
          <button className={[(this.state.instrument=="percussion")?"cat-button-selected":"cat-button"].join(" ")} 
              style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("percussion")}}>Percussion</button>
          <button className={[(this.state.instrument=="orchestra")?"cat-button-selected":"cat-button"].join(" ")} 
              style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("orchestra")}}>Orchestra</button>
          <button className={[(this.state.instrument=="special")?"cat-button-selected":"cat-button"].join(" ")} 
              style={{fontWeight:"bold",marginBottom:"7px"}} onClick={(e)=>{this.changeGroup("special")}}>Special</button>
        </div>
        <Container fluid style={{padding:"2% 5%",fontFamily:"Courgette"}} >
        

         {(Object.keys(this.state.group2).length>0) &&
          <div style={{padding:"0% 1%"}}><Row>
          <Col xs={12} md={12} style={{textAlign:"left", marginLeft:"0%",fontSize:"1.4em"}}>{"Age Group (Free Choice)"}</Col>
          </Row> 
          <Row>
          <Col xs={2} md={2}>Group No.</Col>
          <Col xs={3} md={3}>Group</Col>
          <Col xs={3}  md={3}>Description</Col>
          <Col xs={2} md={2}>Price (USD)</Col>
          <Col xs={2} md={2}>Grand Prize (USD)</Col>
          </Row></div>} 
          { (Object.keys(this.state.group2).length>0) &&
            Object.keys(this.state.group2).map((idx)=>
              <Row key={idx} style={{padding:"0% 1%"}} >
              <Col xs={2} md={2} style={{fontSize:"1em"}}>{this.state.group2[idx]["number"]}</Col>
              <Col xs={3} md={3}>{this.state.group2[idx]["name"]}</Col>
              <Col xs={3} md={3}>{this.state.group2[idx]["des"]}</Col>
              <Col xs={2} md={2}>{this.state.group2[idx]["price"]}</Col>
              <Col xs={2} md={2}>{this.state.group2[idx]["grandprize"]}</Col>
              </Row> 
            )
          }
          <br></br>


         { (Object.keys(this.state.group0).length>0) &&
         <div style={{padding:"0% 1%"}}>
         <Row>
          <Col xs={12} md={12} style={{textAlign:"left", marginLeft:"0%",fontSize:"1.4em"}}>Beginner Group</Col>
          </Row> 
          <Row>
          <Col xs={2} md={1}>Group No.</Col>
          <Col xs={4} md={7}>Group</Col>
          <Col xs={4}  md={3}>Description</Col>
          <Col xs={2} md={1}>Price (USD)</Col>
          </Row> 
          </div>}
          { (Object.keys(this.state.group0).length>0) &&
            Object.keys(this.state.group0).map((idx)=>
              <Row key={idx} style={{padding:"0% 1%"}}>
              <Col xs={2} md={1} style={{fontSize:"1em"}}>{this.state.group0[idx]["number"]}</Col>
              <Col xs={4} md={7}>{this.state.group0[idx]["name"]}</Col>
              <Col xs={4} md={3}>{this.state.group0[idx]["des"]}</Col>
              <Col xs={2} md={1}>{this.state.group0[idx]["price"]}</Col>
              </Row> 
            )
          }

          <br></br>
          {(Object.keys(this.state.group3).length>0) && 
          <div style={{padding:"0% 1%"}}>
            <Row>
          <Col xs={12} md={12} style={{textAlign:"left", marginLeft:"0%",fontSize:"1.4em"}}>Piano Pieces for Children Everybody's Favourite Series No.3</Col>
          </Row> 
          <Row>
          <Col xs={2} md={1}>Group No.</Col>
          <Col xs={4} md={7}>Group</Col>
          <Col xs={4}  md={3}>Description</Col>
          <Col xs={2} md={1}>Price (USD)</Col>
          </Row>
          </div>} 
          { (Object.keys(this.state.group3).length>0) &&
            Object.keys(this.state.group3).map((idx)=>
              <Row key={idx} style={{padding:"0% 1%"}} >
              <Col xs={2} md={1} style={{fontSize:"1em"}}>{this.state.group3[idx]["number"]}</Col>
              <Col xs={4} md={7}>{this.state.group3[idx]["name"]}</Col>
              <Col xs={4} md={3}>{this.state.group3[idx]["des"]}</Col>
              <Col xs={2} md={1}>{this.state.group3[idx]["price"]}</Col>
              </Row> 
            )
          }
          <br></br>
         

          {(Object.keys(this.state.group1).length>0) &&
          <div style={{padding:"0% 1%"}}><Row>
          <Col xs={12} md={12} style={{textAlign:"left", marginLeft:"0%",fontSize:"1.4em"}}>{(this.state.instrument==="recorder")?"Primary School Groups":"ABRSM/Trinity Groups"}</Col>
          </Row> 
          <Row>
          <Col xs={2} md={1} style={{fontSize:"1.2em"}}>{"Group No."}</Col>
          <Col xs={4} md={7} style={{fontSize:"1.2em"}}>{"Group"}</Col>
          <Col xs={4}  md={3} style={{fontSize:"1.2em"}}>{"Description"}</Col>
          <Col xs={2} md={1} style={{fontSize:"1.2em"}}>{"Price (USD)"}</Col>
          </Row></div>}
          { (Object.keys(this.state.group1).length>0) &&
            Object.keys(this.state.group1).map((idx)=>
              <Row key={idx} style={{padding:"0% 1%"}} >
              <Col xs={2} md={1} style={{fontSize:"1em"}}>{this.state.group1[idx]["number"]}</Col>
              <Col xs={4} md={7}>{this.state.group1[idx]["name"]}</Col>
              <Col xs={4} md={3}>{this.state.group1[idx]["des"]}</Col>
              <Col xs={2} md={1}>{this.state.group1[idx]["price"]}</Col>
              </Row> 
            )
          }

<br></br>
          {(Object.keys(this.state.group4).length>0) &&
          <div style={{padding:"0% 1%"}}><Row>
          <Col xs={12} md={12} style={{textAlign:"left", marginLeft:"0%",fontSize:"1.4em"}}>{"Standard Repertoire Groups"}</Col>
          </Row> 
          <Row>
          <Col xs={2} md={1}>Group No.</Col>
          <Col xs={4} md={7}>Group</Col>
          <Col xs={4}  md={3}>Description</Col>
          <Col xs={2} md={1}>Price (USD)</Col>
          </Row></div>}
          { (Object.keys(this.state.group4).length>0) &&
            Object.keys(this.state.group4).map((idx)=>
              <Row key={idx} style={{padding:"0% 1%"}}>
              <Col xs={2} md={1} style={{fontSize:"1em"}}>{this.state.group4[idx]["number"]}</Col>
              <Col xs={4} md={7}>{this.state.group4[idx]["name"]}</Col>
              <Col xs={4} md={3}>{this.state.group4[idx]["des"]}</Col>
              <Col xs={2} md={1}>{this.state.group4[idx]["price"]}</Col>
              </Row> 
            )
          }
 
          </Container>

      </div>
    );
  }
  }
  

export default Category;
